import type { ReactNode } from "react";
import { UserOutlined } from "@ant-design/icons";
import type { Reservation } from "../../../../api/reservations";
import PhoneLink from "../../../../components/PhoneLink";
import { formatClock } from "../../logic/dayTime";
import { reservationEndMs, reservationStartMs } from "../../logic/tableStatus";
import { useReservationFormat } from "../../hooks/useReservationFormat";

/**
 * Данните на резервацията в поповъра: име и час, гости и телефон, ред за
 * статуса (подава се отвън — закъснява / настанени / приключила) и бележка.
 */
const ReservationDetails = ({
  reservation,
  statusLine,
}: {
  reservation: Reservation;
  statusLine: ReactNode;
}) => {
  const format = useReservationFormat();
  const timeRange = `${formatClock(reservationStartMs(reservation))}–${formatClock(
    reservationEndMs(reservation),
  )}`;

  return (
    <div className="flex flex-col gap-2">
      <div>
        <div className="flex items-baseline justify-between gap-3">
          <span className="min-w-0 truncate text-[15px] font-bold leading-[1.3] tracking-[-0.2px] text-ink">
            {reservation.guestName}
          </span>
          <span className="shrink-0 text-[13.5px] font-bold tabular-nums text-ink">{timeRange}</span>
        </div>
        <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-0.5 text-[12.5px] font-medium text-body">
          <span className="flex items-center gap-1.5">
            <UserOutlined className="text-[11px] text-muted" />
            {format.guests(reservation.guests)}
          </span>
          <PhoneLink phone={reservation.phone} withIcon />
        </div>
        {statusLine && <div className="mt-1 text-[12.5px] font-semibold">{statusLine}</div>}
      </div>
      {reservation.note && (
        <div className="rounded-[8px] bg-fill px-2.5 py-2 text-[12.5px] leading-[1.45] text-ink-2">
          {reservation.note}
        </div>
      )}
    </div>
  );
};

export default ReservationDetails;
